import React, { useState, useEffect } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { Eye, XCircle, Edit3 } from "react-feather";
import AddStaff from "./AdminComp/AddStaff";
import axios from "axios";
import { baseurl } from "../../component/Baseurl"; // Assuming baseurl is set properly
import Swal from "sweetalert2"; // Import SweetAlert2


function AllStaff() {
  const [staffData, setStaffData] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [loading, setLoading] = useState(true); // Loading state

  const moduleMapping = {
    1: "Dashboard",
    2: "Bookings",
    3: "Reports",
    4: "Settings"
  };

  // Fetch staff data from the API when the component mounts
  useEffect(() => {
    const fetchStaffData = async () => {
      try {
        const response = await axios.get(`${baseurl}/getadmins`);
        if (response.data.message === "Admins fetched successfully") {
          setStaffData(response.data.admins);
        }
      } catch (error) {
        console.error("Error fetching staff data:", error);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchStaffData();
  }, []);

  // Filter staff based on the search term
  const filteredStaff = staffData.filter(
    (staff) =>
      staff.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      staff.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      staff.phone.includes(searchTerm)
  );

  const totalRecords = filteredStaff.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex = (currentPage - 1) * recordsPerPage;
  const paginatedStaff = filteredStaff.slice(
    startIndex,
    startIndex + recordsPerPage
  );

  const handleView = (staff) => {
    setSelectedStaff(staff);
    const modal = new window.bootstrap.Modal(
      document.getElementById("staffDetailModal")
    );
    modal.show();
  };

  const handleEdit = (id) => {
    alert(`Edit staff ID ${id}.`);
  };

  const handleDelete = (id) => {
    // Show SweetAlert2 confirmation dialog
    Swal.fire({
      title: 'Are you sure?',
      text: "This action cannot be undone.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Send delete request to backend API using POST and send ID in the body
          const response = await axios.post(`${baseurl}/deletestaff`, { id });
  
          if (response.status === 200) {
            // Show success alert
            Swal.fire({
              icon: 'success',
              title: 'Deleted!',
              text: 'Staff member has been deleted successfully.',
              showConfirmButton: false,
              timer: 1500,
            });
            // Remove the deleted staff from the list
            setStaffData(staffData.filter(staff => staff.id !== id));
          } else {
            // Show error alert if the response is not successful
            Swal.fire({
              icon: 'error',
              title: 'Error!',
              text: response.data.message || 'Failed to delete the staff member.',
            });
          }
        } catch (error) {
          console.error("Error deleting staff:", error);
          // Show network error alert
          Swal.fire({
            icon: 'error',
            title: 'Network error',
            text: 'Please try again later.',
          });
        }
      }
    });
  };
  

  const handlePageChange = (page) => setCurrentPage(page);

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <BreadCrumb />
          <div className="container-fluid">
            <div className="crdmain mb-2">
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <h2 className="chart-title mb-0">All Staff</h2>
                <div className="ms-auto">
                  <AddStaff />
                </div>
              </div>

              <div className="row g-1 mt-0 mb-0 justify-content-end">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="input1"
                    placeholder="Search by name, email, phone"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="col-md-1 text-end">
                  <select
                    className="input1"
                    value={recordsPerPage}
                    onChange={handleRecordsPerPageChange}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </select>
                </div>
              </div>

              <div className="row g-2 mt-0 mb-0">
                <div className="col-md-12 p-0">
                  <div className="table-responsive classic-table">
                    <table className="table table-striped table-hover">
                      <thead className="table-header">
                        <tr>
                          <th>#</th>
                          <th>Staff Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Role</th>
                          <th>Unique ID</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? ( // Show loader while fetching data
                          <tr>
                            <td colSpan="8" className="text-center">
                              <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : totalRecords === 0 ? ( // No records found
                          <tr>
                            <td colSpan="8" className="text-center">
                              No records found.
                            </td>
                          </tr>
                        ) : (
                          paginatedStaff.map((staff, index) => (
                            <tr key={staff.id}>
                              <td>{startIndex + index + 1}</td>
                              <td>{staff.name}</td>
                              <td>{staff.email}</td>
                              <td>{staff.phone}</td>
                              <td>{staff.role}</td>
                              <td>{staff.admin_unique_id}</td>
                              <td>{staff.admin_status}</td>
                              <td>
                                <span
                                  className="btn2 me-2"
                                  title="View Details"
                                  onClick={() => handleView(staff)}
                                >
                                  <Eye size={15} />
                                </span>
                                <span
                                  className="btn2 me-2"
                                  title="Edit"
                                  onClick={() => handleEdit(staff.id)}
                                >
                                  <Edit3 size={15} />
                                </span>
                                <span
                                  className="btn2"
                                  title="Delete"
                                  onClick={() => handleDelete(staff.id)}
                                >
                                  <XCircle size={15} />
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <nav>
                  <ul className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                        key={index}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staffDetailModal"
        tabIndex="-1"
        aria-labelledby="staffDetailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staffDetailModalLabel">
                Staff Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {selectedStaff && (
                <table className="table">
                  <tbody className="text-start">
                    <tr>
                      <th>Name</th>
                      <td>{selectedStaff.name}</td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{selectedStaff.email}</td>
                    </tr>
                    <tr>
                      <th>Phone</th>
                      <td>{selectedStaff.phone}</td>
                    </tr>
                    <tr>
                      <th>Role</th>
                      <td>{selectedStaff.role}</td>
                    </tr>
                    <tr>
                      <th>Unique ID</th>
                      <td>{selectedStaff.admin_unique_id}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td className="text-capitalize">
                        {selectedStaff.admin_status === "active" ? (
                          <span className="badge bg-success">Active</span>
                        ) : selectedStaff.admin_status === "inactive" ? (
                          <span className="badge bg-danger">Inactive</span>
                        ) : (
                          <span className="badge bg-secondary">Unknown</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>Modules</th>
                      <td>
                        {selectedStaff.modules.length > 0 ? (
                          selectedStaff.modules.map((moduleId) => (
                            <span key={moduleId} className="badge bg-info me-2">
                              {moduleMapping[moduleId] || `Module ${moduleId}`}
                            </span>
                          ))
                        ) : (
                          <span>No modules assigned</span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllStaff;
